/** Application version number. Needs to be incremented with every important change. */
export const APP_VERSION = '1.001';


// WEBPACK FOOTER //
// ./frontend/scripts/version.ts